// import {config} from "@/config";
import request from "@/utils/request";

export function createCompany(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + "/company/createTeamAndMain",
    data: data,
  });
}
export function baseInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + "/cooperativePartner/baseInfo",
    data: data,
  });
}
export function updateComInfoForOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET_CUST + "/companyInfor/updateComInfoForOrder",
    data,
  });
}
export function getUserInfoByMobilePhone(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET_CUST + "/userInfo/getUserInfoByMobilePhone",
    data,
  });
}

export function queryIndustry(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET_CUST + "/dict/queryDictTree",

    data: data,
  });
}
export function queryComListForOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET_CUST + "/companyInfor/queryComListForOrder",
    data,
  });
}

export function companyManagement(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + "/company/queryCompanyList",
    data: data,
  });
}

export function queryCompanyBySkyEye(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + "/cooperativePartner/search",
    // headers: { 'Authorization': 'XtJMTI2e3fRChHA8vg7rUSN4dZKyD0FWuOY6' },
    data: data,
  });
}
export function ordersList(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/list",
    data: data,
  });
}

export function queryCompanyForAdmin(data) {
  return request({
    url:
      process.env.VUE_APP_BASE_TVRJET_CUST + "/companyInfor/queryCompanyForAdmin" + data,
    method: "GET",
  });
}
export function queryComInfoForId(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET_CUST + "/companyInfor/queryComInfoForId",
    data,
  });
}
export function ordersDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/" + data,
    method: "GET",
  });
}

export function appDetailInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET_THIRD + "/thirdParty/detailsApp",
    data: data,
  });
}

export function pay(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/qrcodePay",
    data: data,
  });
}

export function rePay(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/pay/" + data,
    method: "GET",
  });
}

export function payInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/payInfo",
    method: "GET",
    data: data,
  });
}

export function offlinePay(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/offlinePay",
    data: data,
  });
}

export function applyInvoice(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/invoices/apply",
    data: data,
  });
}

export function savePayVoucher(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/savePayVoucher",
    data: data,
  });
}

export function detailCom(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET_CUST + "/companyInfor/detailCom",
    data: data,
  });
}
export function invoiceTitleList(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/invoicesTitle/list",
    data: data,
  });
}
export function invoiceTitleSave(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/invoicesTitle/save",
    data: data,
  });
}
export function invoiceTitleDelete(data) {
  return request({
    url:
      process.env.VUE_APP_BASE_URL_API +
      "/companyOrders/invoicesTitle/delete?id=" +
      data,
    data: data,
  });
}

export function orderPayAudit(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/companyOrders/orderPayAudit/" + data,
    method: "GET",
  });
}

export function customerService(data) {
  return request({
    url:
      process.env.VUE_APP_BASE_URL_API + "/companyOrders/customerServicePerson/detail",
    method: "GET",
  });
}
